import React from 'react'

import { Column, Text } from 'Components/UI'

import { FOOTER_NAV_LINKS } from './constants'
import { Container, StyledLink } from './styles'

function FooterNavigation() {
  return (
    <Container
      aria-label="Footer"
      as="nav"
      flexDirection={['column', 'column', 'row']}
      gap={[11, 11, 17]}
    >
      {FOOTER_NAV_LINKS.map(item => (
        <Column gap={5} key={item.id}>
          <Text body12 invertedMuted uppercase>
            {item.caption}
          </Text>

          <Column>
            {item.items.map(subitem => (
              <StyledLink href={subitem.link} key={subitem.id}>
                <Text as="span" body14 nowrap semiLight>
                  {subitem.caption}
                </Text>
              </StyledLink>
            ))}
          </Column>
        </Column>
      ))}
    </Container>
  )
}

export default FooterNavigation
